import Link from '@mui/material/Link';
import { useEventBus } from '../../../../../../hooks/use-event-bus';
import FormsService from '../../../../../../services/forms-service/forms-service';
import { FormAssignmentDto } from '../../../../../../services/forms-service/forms-service-types';
import { Buttons } from './forms.styles';

export const Action = ({ form, formsService }: { form: FormAssignmentDto; formsService: FormsService }) => {
  const { publish } = useEventBus();

  const downloadHandle = () => {
    formsService
      .getPdf({
        formId: form.submitted ? form.submissionId! : form.formId!,
        isSubmitted: !!form.submitted
      })
      .then((pdf) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(pdf);
        link.download = `${form.formName}.pdf`;

        link.click();

        URL.revokeObjectURL(link.href);
        link.remove();
      });
  };

  const unassignHandle = () => {
    publish({
      messageType: 'formsDialog',
      data: { type: 'unassign', formId: form.id!, formName: form.formName! }
    });
  };

  return (
    <Buttons>
      <Link component="button" variant="body2" onClick={unassignHandle}>
        Unassign
      </Link>
      {' \u2022 '}
      <Link component="button" variant="body2" onClick={downloadHandle}>
        Download
      </Link>
    </Buttons>
  );
};
